import { FC } from 'react';

type Props = {
	className?: string;
};

const TickDouble_02: FC<Props> = ({ className }) => {
	return (
		<svg
			width='20'
			height='20'
			viewBox='0 0 20 20'
			xmlns='http://www.w3.org/2000/svg'
			fill='none'
			stroke='#2B2B2B'
			className={className}>
			<path
				d='M3.08984 11.3334L5.63535 14.0002L6.38011 13.2199M13.2719 6L8.86232 10.6195'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M6.72656 11.3334L9.27207 14.0002L16.9086 6'
				stroke='inherit'
				strokeWidth='1.25'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default TickDouble_02;
